window.eventLoad = function (id) {
  // console.log(id);
};

document.addEventListener('DOMContentLoaded', function () {
  // ymaps.ready(function (){
  //     window.maps.init()
  // })

  window.maps = {
    list: document.querySelectorAll('.jsMap'),

    init: function () {
      window.maps.list = document.querySelectorAll('.jsMap');

      for (let index = 0; index < window.maps.list.length; index++) {
        const item = window.maps.list[index];
        let coord = item.getAttribute('data-map-coordinates') ? JSON.parse(item.getAttribute('data-map-coordinates')) : [[59.938955, 30.315644]];
        let zoom = item.getAttribute('data-map-zoom') ? item.getAttribute('data-map-zoom') : 16;

        if (window.maps['item_' + index]) {
          window.maps['item_' + index].map.destroy();
        }
        let map = {
          element: item,
          zoom: zoom,
          coordinates: item.getAttribute('data-map-coordinates') ? JSON.parse(item.getAttribute('data-map-coordinates')) : '',

          map: new ymaps.Map(item, {
            controls: [],
            center: coord[0],
            zoom: zoom
          }),

          initDots: function () {
            if (this.coordinates != '') {
              for (let dotIndex = 0; dotIndex < this.coordinates.length; dotIndex++) {
                const thisDot = this.coordinates[dotIndex];
                this.addMark(thisDot);
              }
            }
          },

          addMark: function (cors, id, type) {
            let icon = () => {
              switch (type) {
                case 'default':
                  return `<div class="map__dot">
                                                <span></span>
                                            </div>`;

                case 'artist':
                  return `<div class="map__dot map__dot--artist">
                                                <svg class="icon">
                                                    <use xlink:href="#music"></use>
                                                </svg>
                                            </div>`;

                case 'artist-sm':
                  return `<div class="map__dot map__dot--artist-sm">
                                                <svg class="icon">
                                                    <use xlink:href="#music"></use>
                                                </svg>
                                            </div>`;

                case 'artist-md':
                  return `<div class="map__dot map__dot--artist-md">
                                                <svg class="icon">
                                                    <use xlink:href="#music"></use>
                                                </svg>
                                            </div>`;

                case 'artist-ld':
                  return `<div class="map__dot map__dot--artist-ld">
                                                <svg class="icon">
                                                    <use xlink:href="#music"></use>
                                                </svg>
                                            </div>`;

                default:
                  return `<div class="map__dot">
                                                <span></span>
                                            </div>`;
              }
            }

            MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
              icon(),
              {
                build: function () {
                  MyIconContentLayout.superclass.build.call(this);
                  var element = this.getParentElement().getElementsByClassName('map__dot')[0];

                  if (this.isActive) {
                    element.classList.add('is-active');
                  } else if (this.inited) {
                    element.classList.remove('is-active');
                  }

                  if (!this.inited) {
                    this.inited = true;
                    this.isActive = false;

                    this.getData().geoObject.events.add('click', function (e) {
                      map.element.querySelectorAll('.map__dot').forEach(item => {
                        item.classList.remove('is-active')
                      })
                      this.isActive = true;
                      this.rebuild();
                    }, this);

                    map.map.events.add('click', () => {
                      this.isActive = false;
                      this.rebuild();
                    })
                  }
                }
              }
            ),

              placemark = new ymaps.Placemark(cors, {
                id: id ? id : '',
              }, {
                iconLayout: MyIconContentLayout,
                iconShape: {
                  type: 'Circle',
                  coordinates: [0, 0],
                  radius: 16,
                }
              }),

              this.map.geoObjects.add(placemark)

            placemark.events.add('click', function () {
              window.eventLoad(id)
            })

            this.centeredMap();
          },

          centeredMap: function () {
            this.map.setBounds(this.map.geoObjects.getBounds(), {
              checkZoomRange: true,
              zoomMargin: 40
            });
          },
        }

        map.initDots();

        map.map.events.add('click', () => {
          map.element.querySelectorAll('.map__dot').forEach(item => {
            item.classList.remove('is-active')
          })
        })

        window.maps['item_' + index] = map;
      }
    }
  }
})

// document.addEventListener('DOMContentLoaded', ()=>{
//     ymaps.ready(function (){
//         window.maps.item_0.addMark([59.838955, 31.315644], 123, 'artist')
//         window.maps.item_0.addMark([59.938955, 30.315644], 234, 'artist-md')
//         window.maps.item_0.addMark([60.038955, 29.315644], 345, 'artist-ld')
//     })
// })
